export default "__VITE_ASSET__951fe186__"